module.exports = __webpack_public_path__ + "static/media/ic_flow_5.eb76e5a8.jpg";